import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export const useDeleteIdea = createTripMutation<void, { tripId: string; ideaId: string }>({
	mutationFn: async ({ ideaId }) => {
		await api.delete(`/ideas/${ideaId}`)
	},
	invalidate: ({ tripId }) => [queryKeys.ideas(tripId)],
})
